import type { Validation } from "@/lib/validation"

export const referenceToken: Validation.ReferenceToken = `_ValidationReference`
